let inDom = [];
const createdElementFn = (el, binding, vnode, prevVnode) => {
  inDom = [];
  const [count, fixed, width] = binding.value;
  let forLength = count % fixed;
  !!forLength && (forLength = fixed - forLength);
  for (let index = 0; index < forLength; index++) {
    const div = document.createElement("div");
    div.style.width = width;
    el.appendChild(div);
    inDom.push(div);
  }
};
const flexAll = {
  // 在绑定元素的 attribute 前
  // 或事件监听器应用前调用
  created(el, binding, vnode, prevVnode) {},
  // 在元素被插入到 DOM 前调用
  beforeMount: (el, binding, vnode, prevVnode) => {},
  // 在绑定元素的父组件
  // 及他自己的所有子节点都挂载完成后调用
  mounted(el, binding, vnode, prevVnode) {
    createdElementFn(el, binding, vnode, prevVnode);
  },
  // 绑定元素的父组件更新前调用
  beforeUpdate(el, binding, vnode, prevVnode) {},
  // 在绑定元素的父组件
  // 及他自己的所有子节点都更新后调用
  updated(el, binding, vnode, prevVnode) {
    for (let index = 0; index < inDom.length; index++) {
      el.removeChild(inDom[index]);
    }
    inDom = [];
    createdElementFn(el, binding, vnode, prevVnode);
  },
  // 绑定元素的父组件卸载前调用
  beforeUnmount(el, binding, vnode, prevVnode) {},
  // 绑定元素的父组件卸载后调用
  unmounted(el, binding, vnode, prevVnode) {},
};

export default [{ name: "flexAll", flexAll }];
